<script script setup>
  import {
    ref, computed, onMounted, watch,
  } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  // import { useAccountStore } from '@/stores/account.js';
  import { useProjectComposable } from '@/composables/useProjectComposable.js';
  import Tabs from 'primevue/tabs';
  import TabList from 'primevue/tablist';
  import Tab from 'primevue/tab';
  import TabPanels from 'primevue/tabpanels';
  import TabPanel from 'primevue/tabpanel';

  const route = useRoute();
  const router = useRouter();
  const { resetProject } = useProjectComposable();
  // const accountStore = useAccountStore();
  const dashboards = ref([
    {
      label: 'Your opportunities',
      name: 'YourOpportunities',
    },
    {
      label: 'All opportunities',
      name: 'AllOpportunities',
    },
  ]);
  // const isCarrierExecutive = computed(() => accountStore.roleNames.includes('carrier_executive'));
  const params = computed(() => ({
    pageSelected: 1,
    sortDirection: 'asc',
    sortProp: 'statusSortOrder,due_date',
  }));
  const updateRouteParams = () => {
    const nonFilterParams = { ...route.params };

    if (!nonFilterParams.filters) {
      delete nonFilterParams.filters;
    }

    if (!Object.values(nonFilterParams).includes(undefined)) {
      return;
    }

    router.replace({ params: params.value });
  };

  watch(() => route.params, () => {
    updateRouteParams();
  }, { immediate: true });

  /**
   * Adds insights if carrier_executive role
   */
  // const addInsights = () => {
  //   if (isCarrierExecutive) {
  //     dashboards.value.push({
  //       label: 'Insights',
  //       name: 'Insights',
  //     });
  //   }
  // };

  onMounted(() => {
    updateRouteParams();
    resetProject();
    // addInsights();
  });
</script>

<template>
  <div id="container-dashboard">
    <div id="tabs-wrapper">
      <Tabs :value="0">
        <TabList>
          <Tab
            v-for="(dashboard, index) in dashboards"
            :key="dashboard.label"
            :value="index"
            @click="$router.push({
              name: dashboard.name,
              params
            })"
          >
            {{ dashboard.label }}
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel
            v-for="(dashboard, index) in dashboards"
            :key="dashboard.label"
            :value="index"
          >
            <RouterView />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  #container-dashboard {
    box-sizing: border-box;
    min-height: 100vh;
    width: 100%;
  }
</style>
